// extracted by mini-css-extract-plugin
module.exports = {"social-media-grid":"SocialMedia_social-media-grid__2RH2S"};